import type { AnnotationData } from '@/modules/Editor/AnnotationData'
import type { Annotation } from '@/modules/Editor/models/annotation/Annotation'
import { shallowCloneAnnotation } from '@/modules/Editor/models/annotation/cloneAnnotation'

export const updateImageAnnotation = (
  annotation: Annotation,
  newData: AnnotationData,
): Annotation => shallowCloneAnnotation(annotation, { data: { ...annotation.data, ...newData } })
